import "./App.css";
import { useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import CaseStudyDetailPage from "./pages/CaseStudyDetailPage";
import BookCallPage from "./pages/BookCallPage";
import AboutPage from "./pages/AboutPage";
import LinkedInReadsPage from "./pages/LinkedInReadsPage";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
}

const PublicLayout = ({ children }) => (
  <div className="min-h-screen bg-white flex flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/writing" element={<PublicLayout><ArticlesPage /></PublicLayout>} />
          <Route path="/writing/:slug" element={<PublicLayout><ArticleDetailPage /></PublicLayout>} />
          <Route path="/case-studies" element={<PublicLayout><CaseStudiesPage /></PublicLayout>} />
          <Route path="/case-studies/:id" element={<PublicLayout><CaseStudyDetailPage /></PublicLayout>} />
          <Route path="/reads" element={<PublicLayout><LinkedInReadsPage /></PublicLayout>} />
          <Route path="/book" element={<PublicLayout><BookCallPage /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
          <Route path="/saas-comparisons" element={<Navigate to="/writing" replace />} />
          <Route path="/ai-agents" element={<Navigate to="/case-studies" replace />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
